<div class="sat-stat-cards">
  <div class="sat-stat-card sat-stat-card--blue">
    <div class="sat-stat-card__value">{{ stats.categoryCount }}</div>
    <div class="sat-stat-card__label">Attribute Categories</div>
  </div>

  <div class="sat-stat-card sat-stat-card--green">
    <div class="sat-stat-card__value">{{ stats.typeCount }}</div>
    <div class="sat-stat-card__label">Attribute Types</div>
  </div>

  <div class="sat-stat-card sat-stat-card--orange">
    <div class="sat-stat-card__value">{{ stats.totalValues }}</div>
    <div class="sat-stat-card__label">Total Values Defined</div>
  </div>

  <div class="sat-stat-card sat-stat-card--purple">
    <div class="sat-stat-card__value">{{ stats.activeInFilters }}</div>
    <div class="sat-stat-card__label">Active in Filters</div>
  </div>
</div>
